import type { SessionContext } from "../model/CustomerCartTypes";
import type { ArticleData } from "../model/ArticleTypes";
import type { SearchResultEntry } from "../model/ArticleSearchTypes";
import { Request } from "../stores/Requests20";
import { url as encodeUrl } from "../utils/UrlUtil";
import { handleServiceResponse } from "./ServerRequestsInternal";
const BASE_URL = "/ordercapture/article";
const TIMEOUT = 2000;
export async function getArticleData(context: SessionContext, bundleIds: string[]): Promise<Map<string, ArticleData>> {
	const { country, locale, customerId, storeId, fsdAddressId } = context;
	const url =
		BASE_URL +
		encodeUrl`/articles?country=${country}&locale=${locale}&customerId=${customerId}&storeId=${storeId}` +
		`${fsdAddressId ? "&addressId=" + fsdAddressId : ""}&` +
		bundleIds.map((it) => encodeUrl`bundleIds=${it}`).join("&");
	const response = Request.get(url).timeout(TIMEOUT).execute();
	const json = await handleServiceResponse(response);

	if (!json.data || !json.data.articles) {
		return new Map();
	}

	const entries: Array<[string, ArticleData]> = [];

	for (const bundleId in json.data.articles) {
		if (!Object.prototype.hasOwnProperty.call(json.data.articles, bundleId)) {
			continue;
		}

		entries.push([bundleId, json.data.articles[bundleId]]);
	}

	return new Map(entries);
}
export async function getArticleDataBatched(
	context: SessionContext,
	bundleIds: string[],
	batchSize = 10,
): Promise<Map<string, ArticleData>> {
	const chunk = (arr: any[], size: number): any[][] => {
		const batch = arr.slice(0, size);
		return !batch.length ? [] : [batch, ...chunk(arr.slice(size, arr.length), size)];
	};

	const responses: Array<Map<string, ArticleData>> = await Promise.all(
		chunk(bundleIds, batchSize).map((ids) => getArticleData(context, ids)),
	);
	// @ts-expect-error
	return new Map(responses.reduce((agg, res) => [...agg, ...res.entries()], []));
}
export async function searchArticle(
	context: SessionContext,
	query: string,
	signal?: AbortSignal,
): Promise<SearchResultEntry[]> {
	const { country, locale, customerId, storeId, fsdAddressId } = context;
	const url =
		BASE_URL +
		// @ts-expect-error
		encodeUrl`/search?country=${country}&locale=${locale}&customerId=${customerId}&storeId=${storeId}&query=${query}&page=${1}&fsdOnly=${false}` +
		`${fsdAddressId ? "&addressId=" + fsdAddressId : ""}`;
	const response = Request.get(url).timeout(TIMEOUT).withSignal(signal).execute();
	const json = await handleServiceResponse(response);
	return (json.data && json.data.results) || [];
}
